import React, { useEffect, useState } from "react";
import api from "../../api";
import { Users, CheckCircle2, Flame, Gift, TrendingUp } from "lucide-react";

function Card({ icon: Icon, label, value, hint }) {
  return (
    <div className="card-soft p-5">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground">
        <Icon className="w-3 h-3"/> {label}
      </div>
      <div className="font-display text-4xl mt-2">{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-1">{hint}</div>}
    </div>
  );
}

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setS(r.data));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-4xl mb-2">Dashboard</h1>
      <p className="text-muted-foreground mb-8">Aim for 70%+ weekly completion.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        <Card icon={Users} label="Total families" value={s?.total_families ?? "-"}/>
        <Card icon={CheckCircle2} label="Weekly completion rate" value={`${s?.weekly_completion_rate ?? 0}%`}
              hint={`${s?.weekly_completed ?? 0} of ${s?.weekly_started ?? 0} this week`} />
        <Card icon={Flame} label="Avg streak" value={s?.avg_streak ?? "-"}/>
        <Card icon={Gift} label="Wishes redeemed" value={s?.wishes_redeemed ?? 0}/>
        <Card icon={TrendingUp} label="Weekly started" value={s?.weekly_started ?? 0}/>
        <Card icon={CheckCircle2} label="Weekly completed" value={s?.weekly_completed ?? 0}/>
      </div>

      <div className="card-soft p-6">
        <h3 className="font-display text-2xl mb-2">Welcome, content team</h3>
        <p className="text-muted-foreground">
          Upload stories, questions, activities and reflection prompts via Excel.
          Everything is human-curated. AI only personalizes. it never invents.
        </p>
      </div>
    </div>
  );
}
